/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB2Dp8-xYRkgiDfrdxk6vcur-1Uku808RM",
    authDomain: "push-message-expense-mobi.firebaseapp.com",
    databaseURL: "https://push-message-expense-mobi.firebaseio.com",
    projectId: "push-message-expense-mobi",
    storageBucket: "push-message-expense-mobi.appspot.com",
    messagingSenderId: "144348960822",
    appId: "1:144348960822:web:24be973c2247839489e097",
    measurementId: "G-5BS5ZHKJSC"
  }
};
